import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { ChangeNotesModal } from './NotesIndicator';

type ModalProps ={
	modal: ChangeNotesModal
}

const ConfirmationModal: FC<ModalProps> = ({modal}) => {
  return (
		<Dialog open={modal.showModal} onClose={modal.handleCancel}>
			<DialogTitle>{modal.title}</DialogTitle>
			<DialogActions>
				{modal.cancelButtonText && modal.handleCancel && <Button
					variant="outlined"
					color="primary"
					disableElevation
					onClick={() => modal?.handleCancel()}
				>
					{modal.cancelButtonText}
				</Button>}
				<Button
					variant="contained"
					color="primary"
					disableElevation
					onClick={() => modal.handleOk()}
				>
					{modal.okButtonText}
				</Button>
			</DialogActions>
		</Dialog>
  );
};

export default ConfirmationModal;